module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "templatePicker group p-20"
  }, [_c('div', {
    staticStyle: {
      "display": "none",
      "background-color": "#f00",
      "width": "20px",
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "design-options p-10 p-b-0 primarybg",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "btn-group m-r-10",
    staticStyle: {
      "float": "left"
    }
  }, [(!_vm.$auth.user().vendor) ? _c('button', {
    staticClass: "btn btn-outline-primary m-b-10 primaryborder",
    class: {
      'notactive primaryaltbg': (_vm.$route.params.type !== 'all')
    },
    on: {
      "click": function($event) {
        _vm.fetchTemplates('all')
      }
    }
  }, [_vm._v("All Templates")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().vendor) ? _c('button', {
    staticClass: "btn btn-outline-primary m-b-10 primaryborder",
    class: {
      'notactive primaryaltbg': (_vm.$route.params.type !== 'vendor')
    },
    on: {
      "click": function($event) {
        _vm.fetchTemplates('vendor')
      }
    }
  }, [_vm._v(_vm._s(_vm.$auth.user().vendor.data.name))]) : _vm._e()]), _vm._v(" "), (_vm.sizes.length > 1) ? _c('div', {
    staticClass: "selectwrap m-b-10 primaryaltborder"
  }, [_c('span', {
    staticClass: "icon-arrow-down"
  }), _vm._v(" "), _c('select', {
    staticClass: "sizeDropdown",
    on: {
      "change": function($event) {
        _vm.filter('size', $event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Filter by Size")]), _vm._v(" "), _vm._l((_vm.sizes), function(size) {
    return _c('option', {
      domProps: {
        "value": size.list_name
      }
    }, [_vm._v(_vm._s(size.name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkwrap group"
  }, [(_vm.hasUV) ? _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "checkbox m-r-15 m-b-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.pickerState.spot_uv),
      expression: "$store.state.pickerState.spot_uv"
    }],
    attrs: {
      "id": "spot_uv_cbox",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.pickerState.spot_uv) ? _vm._i(_vm.$store.state.pickerState.spot_uv, null) > -1 : (_vm.$store.state.pickerState.spot_uv)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.$store.state.pickerState.spot_uv,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.pickerState, "spot_uv", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.pickerState, "spot_uv", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.pickerState, "spot_uv", $$c)
        }
      }, function($event) {
        _vm.filterSpotUV($event.target)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "spot_uv_cbox"
    }
  }, [_vm._v("\n                            Spot UV\n                        ")])])]) : _vm._e(), _vm._v(" "), (_vm.hasFoil) ? _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "checkbox m-r-15 m-b-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.pickerState.foil),
      expression: "$store.state.pickerState.foil"
    }],
    attrs: {
      "id": "foil_cbox",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.pickerState.foil) ? _vm._i(_vm.$store.state.pickerState.foil, null) > -1 : (_vm.$store.state.pickerState.foil)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.$store.state.pickerState.foil,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.pickerState, "foil", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.pickerState, "foil", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.pickerState, "foil", $$c)
        }
      }, function($event) {
        _vm.filterFoil($event.target)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "foil_cbox"
    }
  }, [_vm._v("\n                            Foil\n                        ")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.templates === null || _vm.templates.length < 1) ? _c('div') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group row pickerContent"
  }, [_c('transition', {
    attrs: {
      "duration": {
        enter: 250
      },
      "enter-active-class": "animated fadeInLeft "
    },
    on: {
      "after-enter": _vm.setHeight
    }
  }, [(_vm.categories.length > 0 && _vm.showSideNav === true) ? _c('ul', {
    staticClass: "sideNav col-md-3 lineheight-3"
  }, [_c('li', {
    staticClass: "categoryList header py-1",
    on: {
      "click": function($event) {
        _vm.$store.state.selectedCategory = null;
        _vm.$router.push(("/templates/" + (_vm.$route.params.type)))
      }
    }
  }, [_vm._v("\n                    Categories\n                ")]), _vm._v(" "), _vm._l((_vm.categories), function(cat) {
    return (!cat.parent) ? _c('li', {
      staticClass: "categoryList py-md-1"
    }, [_c('router-link', {
      staticClass: "parent",
      class: {
        'active': (cat.id === _vm.$route.params.uuid)
      },
      attrs: {
        "to": '/templates/' + _vm.$route.params.type + '/' + cat.id
      }
    }, [_vm._v("\n                            " + _vm._s(cat.name) + "\n                    ")]), _vm._v(" "), _vm._l((cat.subcategories.data), function(subcat) {
      return _c('router-link', {
        key: subcat.id,
        staticClass: "child",
        class: {
          'active': (subcat.id === _vm.$route.params.subcat)
        },
        attrs: {
          "to": '/templates/' + _vm.$route.params.type + '/' + subcat.parent + '/subcategory/' + subcat.id
        }
      }, [_vm._v("\n                            " + _vm._s('-  ' + subcat.name) + "\n                    ")])
    })], 2) : _vm._e()
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'col-md-12': (_vm.categories.length < 1 || _vm.showSideNav === false), 'col-md-9': (_vm.categories.length > 0 && _vm.showSideNav === true)
    }
  }, [_c('div', {
    staticClass: "row m-b-20"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "design-options p-0 primarybg m-b-0",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated slideInLeft",
      "leave-active-class": "animated slideOutLeft"
    }
  }, [(_vm.categories.length > 0 && _vm.$store.state.config.hideSideNav !== true) ? _c('span', {
    staticClass: "icon-view-list btn btn-outline-primary toggle-cats",
    on: {
      "click": _vm.toggleSideNav
    }
  }) : _vm._e()]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb left m-b-0"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.category = null;
        _vm.$router.push(("/templates/" + (_vm.$route.params.type)))
      }
    }
  }, [_vm._v("All Categories")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.$route.params.uuid) ? _c('li', {
    class: {
      'active': (_vm.$route.params.uuid), 'white': (_vm.$route.params.subcat)
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push(("/templates/" + (_vm.$route.params.type) + "/" + (_vm.$route.params.uuid)))
      }
    }
  }, [_vm._v(_vm._s(_vm.fetchCategory(_vm.$route.params.uuid).name))])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.$route.params.subcat) ? _c('li', {
    class: {
      'active': (_vm.$route.params.subcat)
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push(("/templates/" + (_vm.$route.params.type) + "/" + (_vm.$route.params.uuid) + "/subcat/" + (_vm.$route.params.subcat)))
      }
    }
  }, [_vm._v(_vm._s(_vm.fetchCategory(_vm.$route.params.subcat).name))])]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.$route.params.uuid && (_vm.checkSubcats(_vm.$route.params.uuid) === false || _vm.$route.params.subcat) && _vm.templates !== null && _vm.templates.length > 0) ? _c('div', {
    staticClass: "pr-4 right rightNavBtns"
  }, [_c('span', {
    staticClass: "icon-view-tile btn rnButton btn-outline-primary toggle-view mr-2",
    class: {
      active: _vm.isThumbnail
    },
    on: {
      "click": function($event) {
        _vm.isList = !_vm.isList;
        _vm.isThumbnail = !_vm.isThumbnail
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-menu btn rnButton btn-outline-primary toggle-view",
    class: {
      active: _vm.isList
    },
    on: {
      "click": function($event) {
        _vm.isList = !_vm.isList;
        _vm.isThumbnail = !_vm.isThumbnail
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.$store.state.config.hideDeepLinks !== true) ? _c('div', {
    staticClass: "pr-4 right rightNavBtns"
  }, [_c('span', {
    staticClass: "icon-link rnButton btn btn-outline-primary toggle-view",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyUrl($event)
      }
    }
  })]) : _vm._e()], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    },
    on: {
      "after-enter": _vm.setHeight
    }
  }, [(!_vm.$route.params.uuid) ? _c('div', {
    staticClass: "row display-flex"
  }, _vm._l((_vm.categories), function(cat) {
    return (!cat.parent) ? _c('div', {
      staticClass: "template col-lg-3 col-md-4 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "gal-detail thumb m-t-0 m-b-20 clearfix",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push('/templates/' + _vm.$route.params.type + '/' + cat.id)
        }
      }
    }, [(cat.image) ? _c('div', {
      staticClass: "imgCategory",
      style: ('background-image: url(\'' + cat.image + '\')')
    }) : _vm._e(), _vm._v(" "), _c('h4', {
      staticClass: "left m-t-10 m-b-0 templateTitle categoryTitle"
    }, [_c('div', [_vm._v(_vm._s(cat.name))])])])]) : _vm._e()
  }), 0) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    },
    on: {
      "after-enter": _vm.setHeight
    }
  }, [(_vm.$route.params.uuid && _vm.checkSubcats(_vm.$route.params.uuid) != false && !_vm.$route.params.subcat) ? _c('div', {
    staticClass: "row display-flex"
  }, _vm._l((_vm.checkSubcats(_vm.$route.params.uuid)), function(cat) {
    return _c('div', {
      staticClass: "template col-lg-3 col-md-4 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "gal-detail thumb m-t-0 m-b-20 clearfix",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push('/templates/' + _vm.$route.params.type + '/' + _vm.$route.params.uuid + '/subcategory/' + cat.id)
        }
      }
    }, [(cat.image) ? _c('div', {
      staticClass: "imgCategory",
      style: ('background-image: url(\'' + cat.image + '\')')
    }) : _vm._e(), _vm._v(" "), _c('h4', {
      staticClass: "left m-t-10 m-b-0 templateTitle categoryTitle"
    }, [_c('div', [_vm._v(_vm._s(cat.name) + " " + _vm._s(cat.image))])])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.templates !== null && _vm.templates.length < 1),
      expression: "templates !== null && templates.length < 1"
    }],
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('center', [_c('FulfillingBouncingCircleSpinner', {
    attrs: {
      "animation-duration": 2500,
      "size": 45,
      "color": '#232F4B'
    }
  })], 1)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    },
    on: {
      "after-enter": _vm.setHeight
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isThumbnail && _vm.$route.params.uuid && (_vm.checkSubcats(_vm.$route.params.uuid) === false || _vm.$route.params.subcat) && _vm.templates !== null && _vm.templates.length > 0),
      expression: "isThumbnail && $route.params.uuid && (checkSubcats($route.params.uuid) === false || $route.params.subcat) && templates !== null && templates.length > 0"
    }],
    staticClass: "row display-flex"
  }, _vm._l((_vm.templates), function(template, index) {
    return _c('div', {
      staticClass: "col-lg-3 col-md-4 col-sm-6 col-xs-12",
      class: _vm.computedClass('template', [template.category_list, template.finished_height + 'x' + template.finished_width, template.foil, template.spot_uv]),
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.loadTemplate(index)
        },
        "mouseenter": function($event) {
          _vm.flip(index)
        },
        "mouseleave": function($event) {
          _vm.flip(index)
        }
      }
    }, [_c('div', {
      staticClass: "gal-detail thumb m-t-0 m-b-20 clearfix"
    }, [_c('div', {
      staticClass: "imgContainer relative animate"
    }, [_c('img', {
      staticClass: "auto thumb-img animate",
      attrs: {
        "src": template.previews[template.default_image],
        "alt": "",
        "id": template.id
      }
    })]), _vm._v(" "), _c('h4', {
      staticClass: "left m-t-10 m-b-0 templateTitle"
    }, [_c('div', {
      staticClass: "templateName"
    }, [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('div', {
      staticClass: "templateDescription"
    }, [_vm._v(_vm._s(template.description))]), _vm._v(" "), _vm._l((template.categories.data), function(cat) {
      return _c('span', {
        staticClass: "m-r-5 left"
      }, [_c('small', [_vm._v(_vm._s(cat.name) + "  ")])])
    }), _vm._v(" "), _c('span', {
      staticClass: "m-r-5 right"
    }, [_c('small', [_vm._v(_vm._s(template.finished_width) + " x " + _vm._s(template.finished_height))])])], 2)])])
  }), 0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    },
    on: {
      "after-enter": _vm.setHeight
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isList && _vm.$route.params.uuid && (_vm.checkSubcats(_vm.$route.params.uuid) === false || _vm.$route.params.subcat) && _vm.templates !== null && _vm.templates.length > 0),
      expression: "isList && $route.params.uuid && (checkSubcats($route.params.uuid) === false || $route.params.subcat) && templates !== null && templates.length > 0"
    }],
    staticClass: "row"
  }, _vm._l((_vm.templates), function(template, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6"
    }, [_c('div', {
      class: _vm.computedClass('template', [template.category_list, template.finished_height + 'x' + template.finished_width, template.foil, template.spot_uv]),
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.loadTemplate(index)
        }
      }
    }, [_c('div', {
      staticClass: "gal-detail listview thumb m-t-0 m-b-10"
    }, [_c('div', {
      staticClass: "imgContainer"
    }, [_c('img', {
      staticStyle: {
        "height": "100%",
        "width": "auto"
      },
      attrs: {
        "src": template.previews[template.default_image],
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-left listview-text"
    }, [_c('div', {
      staticClass: "vertical-align-ab animate description"
    }, [_vm._v(_vm._s(template.description))]), _vm._v(" "), _c('h4', {
      staticClass: "m-0 animate"
    }, [_c('span', {
      staticClass: "text-primary"
    }, [_vm._v(_vm._s(template.name))]), _c('br'), _vm._v(" "), _vm._l((template.categories.data), function(cat) {
      return _c('span', {
        staticClass: "m-r-5 text-muted"
      }, [_vm._v("\n                                            " + _vm._s(cat.name) + "\n                                        ")])
    }), _vm._v(" "), _c('span', {
      staticClass: "m-r-5 text-muted"
    }, [_vm._v("\n                                         /\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "m-r-5 text-muted"
    }, [_vm._v("\n                                            " + _vm._s(template.finished_width) + " x " + _vm._s(template.finished_height) + "\n                                        ")])], 2)])])])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.pagination.total_pages > 1 && _vm.$route.params.uuid && (_vm.checkSubcats(_vm.$route.params.uuid) === false || _vm.$route.params.subcat) && _vm.templates !== null && _vm.templates.length > 0) ? _c('nav', {
    staticClass: "mt-3"
  }, [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": Number(_vm.pagination.total_pages),
      "click-handler": _vm.paginateTemplates,
      "margin-pages": 2,
      "initial-page": ((this.$route.params.page) ? parseInt(this.$route.params.page - 1) : 0),
      "force-page": ((this.$route.params.page) ? parseInt(this.$route.params.page - 1) : 0),
      "prev-text": '‹',
      "next-text": '›',
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "next-link-class": 'page-link',
      "prev-link-class": 'page-link'
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18f37940","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TemplatePicker.vue
// module id = 238
// module chunks = 0